// require('./modules/bootstrap');
import axios from "axios";


axios.defaults.headers.common = {
    'X-Requested-With' : 'XMLHttpRequest',
    'X-CSRF-TOKEN'     : document.querySelector( 'meta[name="csrf-token"]' ).getAttribute( 'content' ),
};

import AdfNav            from './modules/nav';
import AdfHeaderSearch   from './modules/headerSearch';
import AdfFooter         from './modules/footer';
import AdfSmoothScroll   from './modules/smoothScroll';
import AdfSideToc        from './modules/sideToc';
import AdfSearchBar      from './modules/searchBar';
// import AdfArticlesPage   from './modules/articles';
import AdfFilters        from "./modules/filters";
import AdfInputs         from './modules/form';
import AdfCaroussel      from './modules/caroussel';
import AdfProfile        from "./modules/profile/profile";
import AdfConnected      from "./modules/connected";
import AdfFolders        from "./modules/folders"; // @todo had to remove
// import AdfChatbot        from "./modules/chatbot";
import { initChatbot }   from "./modules/chatbot/chatbot";
import AdfCollection     from "./modules/collection";
// import Swal              from 'sweetalert2'
import AdfShare          from "./modules/share";
import AdfNewsletter     from "./modules/newsletter";
import AdfResource       from "./modules/resource";
import AdfLostPassword   from "./modules/lost-password";
import AdfCookieBar      from "./modules/cookieBar";
import AdfAnimations     from './modules/animations';
import AdfShowHideHeader from './modules/showHideHeader';
import AdfFooterLinks    from './modules/FooterLinks';



async function onReady ()
{
    let strPageType = document.querySelector( "body" ).attributes[ "data-page-id" ].value;

    const adfShowHideHeader = new AdfShowHideHeader();
    const adfNav            = new AdfNav();
    const adfHeaderSearch   = new AdfHeaderSearch();
    const adfFooter         = new AdfFooter();
    const adfSmoothScroll   = new AdfSmoothScroll()
    const adfSideToc        = new AdfSideToc();
    const adfSearchBar      = new AdfSearchBar();
    // const adfArticlesPage   = new AdfArticlesPage();
    const adfFilters        = new AdfFilters();
    const adfInputs         = new AdfInputs();
    const adfConnected      = new AdfConnected();
    // const adfChatbot        = new AdfChatbot();

    const adfAnimations = new AdfAnimations();

    const adfFooterLinks = new AdfFooterLinks();

    //let user = await adfConnected.getUserInfo();

    let carousels    = document.querySelectorAll( '.resources.swiper' );
    let arrCarousels = Array.from( carousels );

    arrCarousels.forEach( ( el, i ) =>
    {
        var adfCaroussel = new AdfCaroussel( el );
    } );


    if ( [ "profil" ].includes( strPageType ) )
    {
        new AdfProfile();
    }

    if ( [ "folders", "folder" ].includes( strPageType ) )
    {
        new AdfFolders();
    }

    if ( [ "collection-single" ].includes( strPageType ) )
    {
        new AdfCollection();
    }

    if ( [ "resources-single", "article-single" ].includes( strPageType ) )
    {
        new AdfShare();
    }

    if ( [ "resources-single" ].includes( strPageType ) )
    {
        new AdfResource();
    }

    if ( [ "page-single", "newsletter" ].includes( strPageType ) )
    {
        let isHome = document.body.classList.contains( "home" );

/*console.log(( "isHome", isHome ))*/;        new AdfNewsletter();
    }

    if ( [ "lost-password" ].includes( strPageType ) )
    {
        new AdfLostPassword( adfNav );
    }


    await adfConnected.bindUserFavouritesButtons();

    initChatbot ();

    /**
     * This should invalidate any clicks on upcoming Resources
     * ( published but with an availability date in the future ( "bientôt" ) )
     */
    document.addEventListener( 'click', ( e ) =>
    {
        // loop parent nodes from the target to the delegation node
        for ( let target = e.target; target && target !== this; target = target.parentNode )
        {
            if ( typeof target.matches === 'function' && target.matches( '.ne-pas-suivre' ) )
            {

                e.preventDefault();
                break;
            }
        }
    }, false );

}

document.addEventListener( "DOMContentLoaded", onReady );


console.log( __MIX_COMPILATION_DATE__ );




